import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';
import { HomeScreen } from './screens/Home/Home.screen';
import { CategoryScreen } from './screens/Category';
import { LikeScreen } from './screens/Like';
import { FolderDetailScreen } from './screens/FolderDetail';
import { LikeMarketListScreen } from './screens/LikeMarketList';
import { EditGoodsLikeScreen } from './screens/EditGoodsLike';
import { GoodsRankingScreen } from './screens/Home/GoodsRanking.screen';
import { MarketRankingScreen } from './screens/Home/MarketRanking.screen';
import { FragmentTodayScreen } from './screens/Home/Today.screen';
import { ServiceMapScreen } from './screens/ServiceMap';
import { CartScreen } from './screens/Cart';
import { CartSelectCouponScreen } from './screens/CartSelectCoupon';

export type HomeStackParamList = {
  Home: {
    selected?: string;
    market_type_sno?: string;
  };
  EditGoodsLike: {
    instanceId?: string;
    categorySno?: number | null;
    isDeliveryFilterOn?: boolean;
    order?: string | null;
  };
};

export const HomeScreens: ScreenItem[] = [
  // {
  //   name: 'Home',
  //   component: HomeScreen,
  //   path: '/',
  //   options: {
  //     tabBarLabel: '홈',
  //   },
  // },
  // {
  //   name: 'Category',
  //   component: CategoryScreen,
  //   path: '/category',
  //   options: {
  //     tabBarLabel: '카테고리',
  //   },
  // },
  {
    name: 'EditGoodsLike',
    component: EditGoodsLikeScreen,
    path: WEB_ROUTE_PATHS.EditGoodsLike,
    options: {
      title: '전체 상품 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : (props.extras ?? {});

      return {
        categorySno:
          typeof extras.category_sno === 'string'
            ? Number(extras.category_sno)
            : (extras.category_sno ?? null),
        isDeliveryFilterOn:
          typeof extras.is_fast_delivery === 'string'
            ? extras.is_fast_delivery === 'true'
            : Boolean(extras.is_fast_delivery),
        order: extras.order ?? null,
      };
    },
  },
  {
    name: 'LikeMarketList',
    component: LikeMarketListScreen,
    path: '/like-markets',
  },
  {
    name: 'FolderDetail',
    component: FolderDetailScreen,
    path: WEB_ROUTE_PATHS.FolderDetail,
    convertParams: props => {
      const target = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;
      const extras =
        typeof target === 'string'
          ? (() => {
              try {
                return JSON.parse(target);
              } catch {
                return {};
              }
            })()
          : (target ?? {});
      return {
        folderSno: Number(extras.sno ?? extras.folderSno ?? props.params ?? 0),
      };
    },
  },
  {
    name: 'GoodsRanking',
    component: GoodsRankingScreen,
    path: '/goods-ranking',
  },
  {
    name: 'MarketRanking',
    component: MarketRankingScreen,
    path: '/market-ranking',
  },
  {
    name: 'LikeFragment',
    component: LikeScreen,
    path: '/like-fragment',
  },
  {
    name: 'FragmentsOverView',
    component: CategoryScreen,
    path: '/fragments/overview',
  },
  {
    name: 'FragmentsLike',
    component: LikeScreen,
    path: '/fragments/like',
  },
  {
    name: 'FragmentToday',
    component: FragmentTodayScreen,
    path: '/fragments/today',
  },
  {
    name: 'ServiceMap',
    component: ServiceMapScreen,
    path: WEB_ROUTE_PATHS.ServiceMap,
    options: {
      title: '전체메뉴',
    },
  },
  {
    // path 를 /cart 로 등록해 주소가 그대로 유지되게 한다. 뒤에 딸린 쿼리 파라미터는
    // react-navigation linking 이 route.params 로 넘겨주고, 화면이 웹뷰 URL 로 이어붙인다.
    name: 'Cart',
    component: CartScreen,
    path: WEB_ROUTE_PATHS.Cart,
    options: {
      title: '장바구니',
    },
  },
  {
    name: 'CartSelectCoupon',
    component: CartSelectCouponScreen,
    path: WEB_ROUTE_PATHS.CartSelectCoupon,
    options: {
      title: '쿠폰 선택',
    },
  },
];
export const HomeTabScreens: ScreenItem[] = [
  {
    name: 'Home',
    screenName: 'HOME',
    component: HomeScreen,
    path: '/:selected?',
    options: {
      tabBarLabel: '홈',
    },
  },
  {
    name: 'Overview',
    screenName: 'OVERVIEW',
    component: CategoryScreen,
    path: '/overview',
    options: {
      tabBarLabel: '카테고리',
    },
  },
  {
    name: 'Like',
    screenName: 'LIKED_GOODS',
    component: LikeScreen,
    path: '/like',
    options: {
      tabBarLabel: '찜',
    },
  },
];
